import httpCommon from '@/api/httpCommon/httpCommon';

/**
 * Fetches Belarus branch data from the server.
 * @returns {Promise<AxiosResponse>} A promise that resolves to the response from the HTTP GET request.
 */
export const getBelarusBranches = async () => {
    return await httpCommon().get('branches/belarus');
};
